import { AccountVerifyCodeContainer } from 'src/containers';
export const AccountVerifyCode = () => <AccountVerifyCodeContainer />;
